import { Injectable } from '@angular/core';
import { Globals } from '.././globals';
import { Http } from "@angular/http";
import { Router } from '@angular/router';

@Injectable()
export class FeedbackService {

  constructor(private http: Http, private globals: Globals, private router: Router) { 
  }

  Register(RegisterEntity){ 
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + 'Feedback/Register', RegisterEntity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
            this.globals.isLoading = false;
            this.router.navigate(['/pagenotfound']);      
          }
        );
    });		
    return promise;
  }

  submitFeedback(data){  debugger
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + 'Feedback/submitFeedback', data)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
            this.globals.isLoading = false;
            this.router.navigate(['/pagenotfound']);      
          }
        );
    });		
    return promise;
  }

  getUserList(){ 
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.globals.baseAPIUrl + 'Feedback/getUserList')
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
            this.globals.isLoading = false;
            this.router.navigate(['/pagenotfound']);      
          }
        );
    });		
    return promise;
  }

}




// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/services/feedback.service.ts